/* EV Tech Spot · spatial guides window (03.11.2026, v2). See snippets/evts-spatial-guides.liquid.
   Filters work everywhere. Desktop with a mouse: one passive scroll listener, one update per animation frame, only
   while the section is on screen; the window rises and tilts into place, the cards drift at their own depth, and the
   window leans a little toward the mouse. Phone and tablet: the window comes in once (IntersectionObserver).
   v2, when the window opens (desktop: it has nearly settled; phone: it has come in): the heading "powers on" like
   the other headings on the page (letters light up with a red current, a red line charges under it: the same
   classes and CSS as evts-home-fx), and the number of guides counts up from 0 to the real number (from the store,
   in the page) once. Each card lights up once when it is reached (IntersectionObserver), 0.1 s apart (phone
   0.08 s): a red line runs around it, then the picture, then the title (evts-spatial.css). Texts are not changed.
   Also loaded on the blog page (sections/main-blog.liquid): any heading with data-evts-power powers on once when
   it comes into view. Reduced motion: no motion at all. */
(function () {
  'use strict';
  var still = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  // ---------- headings "power on" (the same markup and classes as evts-home-fx.js; CSS in evts-home-fx.css) ----------
  // Letters stay inline spans in a row (mixed Hebrew / English keeps its order); the heading gets its text as
  // aria-label, so it is read as one phrase. Dawn's own fade on the heading is taken off (it would fight this).
  function power(h) {
    if (!h || h.__evtsPower) return h;
    h.__evtsPower = true;
    var text = h.textContent.replace(/\s+/g, ' ').trim();
    if (!text) return null;
    h.classList.remove('scroll-trigger', 'animate--fade-in', 'scroll-trigger--offscreen');
    var n = 0, walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT, null), list = [];
    while (walker.nextNode()) list.push(walker.currentNode);
    list.forEach(function (t) {
      var frag = document.createDocumentFragment();
      t.nodeValue.split(/(\s+)/).forEach(function (p) {
        if (!p) return;
        if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
        var w = document.createElement('span');
        w.className = 'evts-w';
        Array.from(p).forEach(function (ch) {
          var c = document.createElement('span');
          c.className = 'evts-c';
          c.setAttribute('data-c', ch);
          c.style.setProperty('--i', n++);
          c.textContent = ch;
          w.appendChild(c);
        });
        frag.appendChild(w);
      });
      t.parentNode.replaceChild(frag, t);
    });
    if (!h.hasAttribute('aria-label')) h.setAttribute('aria-label', text);
    var line = document.createElement('span');
    line.className = 'evts-hline' + (getComputedStyle(h).textAlign === 'center' ? ' evts-hline--c' : '');
    line.setAttribute('aria-hidden', 'true');
    line.innerHTML = '<i></i>';
    line.style.setProperty('--n', n);
    h.appendChild(line);
    h.classList.add('evts-power', 'evts-rv');
    return h;
  }
  function powerOn(h) { if (h) h.classList.add('is-in'); }
  if (!still) {
    [].forEach.call(document.querySelectorAll('[data-evts-power]'), function (h) {
      if (!power(h)) return;
      if (!('IntersectionObserver' in window)) { powerOn(h); return; }
      var hio = new IntersectionObserver(function (es) {
        if (es[0].isIntersecting) { powerOn(h); hio.disconnect(); }
      }, { threshold: 0.3 });
      hio.observe(h);
    });
  }

  var root = document.querySelector('[data-evts-sp]');
  if (!root || root.__evtsSp) return;
  root.__evtsSp = true;
  var win = root.querySelector('[data-evts-sp-win]');
  var pool = root.querySelector('.evts-sp__pool');
  var glare = root.querySelector('.evts-sp__glare');
  var grid = root.querySelector('[data-evts-sp-grid]');
  var cards = [].slice.call(root.querySelectorAll('.evts-sp__card'));
  var tabs = [].slice.call(root.querySelectorAll('.evts-sp__tabs button'));

  // ---------- filters ----------
  tabs.forEach(function (b) {
    b.addEventListener('click', function () {
      var f = b.getAttribute('data-f');
      // keep the window's height while the cards change, so nothing below it jumps
      if (grid && !grid.style.minHeight) grid.style.minHeight = grid.offsetHeight + 'px';
      tabs.forEach(function (x) {
        var on = x === b;
        x.classList.toggle('is-on', on);
        x.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      var k = 0;
      cards.forEach(function (c) {
        var hit = !f || (c.getAttribute('data-tags') || '').indexOf('|' + f + '|') > -1;
        c.hidden = !hit;
        c.classList.remove('is-pop');
        if (hit) {
          c.style.setProperty('--p', k++);
          void c.offsetWidth;
          c.classList.add('is-pop');
        }
      });
    });
  });

  if (still) return;
  root.classList.add('is-js');
  var desk = window.matchMedia('(min-width: 990px) and (hover: hover)');
  var live = false;

  // ---------- heading, number of guides, cards lighting up ----------
  var title = power(root.querySelector('.evts-sp__title'));
  var countUp = counter(root.querySelector('.evts-sp__count'));
  var opened = false, seen = [], order = [];
  function open() {
    if (opened) return;
    opened = true;
    powerOn(title);
    if (countUp) countUp();
    fire();
  }
  // The number counts from 0 to the real number (the one the page shows) once; the words after it stay.
  function counter(el) {
    var t = el && el.firstChild;
    var m = t && t.nodeType === 3 && /^(\s*)(\d+)/.exec(t.nodeValue);
    if (!m) return null;
    var to = +m[2], num = document.createElement('span');
    num.className = 'evts-sp__num';
    num.style.minWidth = m[2].length + 'ch';
    num.textContent = '0';
    t.nodeValue = t.nodeValue.slice(m[0].length);
    el.insertBefore(num, t);
    if (m[1]) el.insertBefore(document.createTextNode(m[1]), num);
    return function () {
      var t0 = 0;
      requestAnimationFrame(function step(now) {
        if (!t0) t0 = now;
        var k = Math.min(1, (now - t0) / 1100), v = String(Math.round(to * (1 - Math.pow(1 - k, 3))));
        if (num.textContent !== v) num.textContent = v;
        if (k < 1) requestAnimationFrame(step); else num.style.minWidth = '';
      });
    };
  }
  // Cards: each lights up once when it is on screen and the window is open; cards that arrive together follow
  // each other in reading order (top to bottom, then left to right).
  cards.forEach(function (c, i) {
    var e = document.createElement('span');
    e.className = 'evts-sp__edge';
    e.setAttribute('aria-hidden', 'true');
    e.innerHTML = '<i></i><i></i><i></i><i></i>';
    c.appendChild(e);
    order[i] = [0, 0];
    c.__i = i;
  });
  function places() { cards.forEach(function (c, i) { order[i] = [Math.round(c.offsetTop / 40), c.offsetLeft]; }); }
  function fire() {
    if (!opened || !seen.length) return;
    var batch = seen.splice(0), step = window.innerWidth < 750 ? 0.08 : 0.1;
    batch.sort(function (a, b) { var x = order[a.__i], y = order[b.__i]; return x[0] - y[0] || x[1] - y[1]; });
    batch.forEach(function (c, k) {
      c.style.setProperty('--w', (k * step).toFixed(2) + 's');
      c.classList.add('is-lit');
      // the running line has done its job: take it away (no layers left behind)
      var e = c.querySelector('.evts-sp__edge');
      if (e) setTimeout(function () { if (e.parentNode) e.parentNode.removeChild(e); }, Math.round((k * step + 1.2) * 1000));
    });
  }
  if ('IntersectionObserver' in window) {
    var cio = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        cio.unobserve(e.target);
        seen.push(e.target);
      });
      fire();
    }, { threshold: 0.25, rootMargin: '0px 0px -5% 0px' });
    cards.forEach(function (c) { cio.observe(c); });
  } else {
    seen = cards.slice();
  }

  function header() {
    var h = document.querySelector('.section-header');
    var r = h ? h.getBoundingClientRect() : null;
    root.style.setProperty('--hdr', (r && getComputedStyle(h).position === 'sticky' ? Math.round(r.height) : 0) + 'px');
  }

  // ---------- on screen? (pauses the floating; reveals the window on phone / tablet) ----------
  var onScreen = false;
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      onScreen = es[0].isIntersecting;
      root.classList.toggle('is-paused', !onScreen);
      if (onScreen) request();
    }, { rootMargin: '10% 0px' }).observe(root);
    var once = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      win.classList.add('is-in');
      if (!desk.matches) {
        setTimeout(function () { win.classList.add('is-live'); }, 500);
        setTimeout(open, 350);   // phone / tablet: open while the window comes in
      }
      once.disconnect();
    }, { threshold: 0.12 });
    once.observe(win);
  } else {
    onScreen = true;
    win.classList.add('is-in');
    open();
  }

  // ---------- desktop: rise, depth and lean ----------
  var ticking = false, top = 0, height = 0, vh = window.innerHeight;
  var mx = 0, my = 0, cx = 0, cy = 0, lastWin = '', lastOp = '', depth = [], lastCard = [];
  cards.forEach(function (c, i) {
    depth[i] = parseFloat(c.style.getPropertyValue('--d')) || 0.5;
    lastCard[i] = '';
  });
  function request() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
  function measure() {
    vh = window.innerHeight;
    header();
    var r = root.getBoundingClientRect();
    top = r.top + (window.pageYOffset || 0);
    height = r.height;
    places();
    request();
  }
  function clear() {
    if (!lastWin) return;
    win.style.transform = '';
    win.style.opacity = '';
    if (pool) { pool.style.transform = ''; pool.style.opacity = ''; }
    cards.forEach(function (c, i) { c.style.transform = ''; lastCard[i] = ''; });
    lastWin = '';
    lastOp = '';
  }
  function frame() {
    ticking = false;
    if (!desk.matches) { clear(); return; }
    if (!onScreen) return;
    var y = window.pageYOffset || 0;
    var pin = Math.max(1, height - vh);
    // rise: from the moment the section top is at 95 % of the screen until 35 % of the pinned part
    var s = (y - (top - vh * 0.95)) / (vh * 0.95 + pin * 0.35);
    s = s < 0 ? 0 : s > 1 ? 1 : s;
    var e = 1 - Math.pow(1 - s, 3);
    var p = (y - top) / pin;
    p = p < 0 ? 0 : p > 1 ? 1 : p;
    cx += (mx - cx) * 0.1;
    cy += (my - cy) * 0.1;
    var rx = (1 - e) * 30 - cy * 5, ry = cx * 7;
    var tf = 'translateY(' + ((1 - e) * 24).toFixed(2) + 'vh) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) scale(' + (0.86 + 0.14 * e).toFixed(4) + ')';
    if (tf !== lastWin) { win.style.transform = tf; lastWin = tf; }
    var op = Math.min(1, s * 2.4).toFixed(3);
    if (op !== lastOp) {
      win.style.opacity = op;
      if (pool) { pool.style.opacity = (e * e).toFixed(3); pool.style.transform = 'scaleX(' + (0.6 + 0.4 * e).toFixed(3) + ')'; }
      lastOp = op;
    }
    if (s > 0.85) open();   // the window has nearly settled: heading, number and cards
    // the scan line runs once when the window settles; again after the visitor scrolls back up past it
    if (!live && s > 0.97) { live = true; win.classList.remove('is-live'); void win.offsetWidth; win.classList.add('is-live'); }
    else if (live && s < 0.3) { live = false; win.classList.remove('is-live'); }
    for (var i = 0; i < cards.length; i++) {
      var d = depth[i];
      var ty = (1 - e) * d * 160 + (p - 0.5) * d * -40 - cy * d * 8;
      var tx = -cx * d * 12;
      var ct = 'translate3d(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px,0)';
      if (ct !== lastCard[i]) { cards[i].style.transform = ct; lastCard[i] = ct; }
    }
    if (Math.abs(mx - cx) > 0.002 || Math.abs(my - cy) > 0.002) request();
  }
  window.addEventListener('scroll', request, { passive: true });
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);
  if (window.ResizeObserver) {
    var roPending = false;
    new ResizeObserver(function () {
      if (roPending) return;
      roPending = true;
      requestAnimationFrame(function () { roPending = false; measure(); });
    }).observe(document.body);
  }
  root.addEventListener('pointermove', function (ev) {
    if (ev.pointerType !== 'mouse') return;
    mx = ev.clientX / window.innerWidth - 0.5;
    my = ev.clientY / window.innerHeight - 0.5;
    if (glare) {
      var r = win.getBoundingClientRect();
      var inside = ev.clientX > r.left && ev.clientX < r.right && ev.clientY > r.top && ev.clientY < r.bottom;
      win.classList.toggle('is-glare', inside);
      if (inside) glare.style.transform = 'translate(' + Math.round(ev.clientX - r.left) + 'px,' + Math.round(ev.clientY - r.top) + 'px)';
    }
    request();
  }, { passive: true });
  root.addEventListener('pointerleave', function () { mx = 0; my = 0; win.classList.remove('is-glare'); request(); });
  if (desk.addEventListener) desk.addEventListener('change', measure);
  measure();
})();